import { useState } from 'react'

export const useDialog = () => {
  const [isDialogOpen, setDialogOpen] = useState(false)
  const handleClose = () => setDialogOpen(false)
  const handleOpen = () => setDialogOpen(true)

  return { isDialogOpen, handleClose, handleOpen }
}

type HandleClose = () => void
type HandleOpen = () => void

export const useDialogArray = (): [boolean, HandleClose, HandleOpen] => {
  const [isDialogOpen, setDialogOpen] = useState(false)
  const handleClose = () => setDialogOpen(false)
  const handleOpen = () => setDialogOpen(true)

  return [isDialogOpen, handleClose, handleOpen]
}
